import { canUseDOM } from 'exenv';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import get from 'lodash/get';
import assign from 'lodash/assign';
import Cookies from 'js-cookie';
import matchMediaDesktop from '../../../../utils/client_util';
import RelatedPosts from '../../related_posts/related_posts';
import RelatedParselyPosts from '../../related_posts/related_parsely_posts';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';
import {
  isAdvertorial,
  isCustom
} from '../../../../views/components/advertorial/advertorial';
import SiderailVideoModuleReactJW from '../../siderail_video_module/siderail_video_module_reactjw';
import { isCategory } from '../../../../utils/category_util';
import generateVideoCustomParams from '../../../../utils/seo_utils/video/video_post_custom_params_util';
import AdContainer from '../../ad/AdContainer';

export default class Sidebar extends Component {
  constructor(props) {
    super(props);

    // binds
    this.buildClassName = this.buildClassName.bind(this);

    // var init
    this.showReccommendedWidget = false;
    this.sidebarVideo = false;
    this.isMobile = false;
    this.useMicrosoftPlaylist =
      isCategory(get(props, 'post.categories', []), 'recommender') ||
      isCategory(get(props, 'post.categories', []), 'magazine');
  }

  componentDidMount() {
    this.checkWindowSize();
    window.addEventListener('resize', this.checkWindowSize.bind(this));
  }

  checkWindowSize() {
    this.isMobile = window.innerWidth < 1024;
  }

  buildClassName() {
    const { fullPageAdvertorial, isVideoPost } = this.props;
    const className = ['post__promotion'];

    if (isVideoPost) {
      className.push('post__promotion--video');
    }

    if (fullPageAdvertorial) {
      className.push('post__promotion--advertorial');
    }

    return className.join(' ');
  }

  buildSidebar() {
    const {
      config,
      post,
      isFirstPost,
      isDesktop,
      related,
      fullPageAdvertorial,
      totalAdCount,
      isLongPost,
      isVideoPost
    } = this.props;

    const totalAds = isLongPost && !isVideoPost ? totalAdCount : 1;
    const ads = [];
    const readTime = get(post, 'readTime');
    const hasPosterVideo = get(post, 'posterVideo.feedId');
    const isListPage = get(this.props, 'posts.length') > 1;
    const customparams = generateVideoCustomParams(post);

    if (config.initialPageLoad || !canUseDOM || !matchMediaDesktop()) {
      return null;
    }

    const tags = get(post, 'tags');
    // Note: having fc_rev_content means the user is from international
    const videoSidebar =
      isFirstPost &&
      !hasPosterVideo &&
      !isVideoPost &&
      !isAdvertorial(get(post, 'tags')) &&
      !isListPage &&
      !tags.filter(tag => tag.slug === 'davos-dialogues').length &&
      !tags.filter(tag => tag.slug === '_advertorial_mic_summit').length &&
      !this.isMobile;

    if (videoSidebar) {
      Cookies.set('alreadySeenRightRailPlayer', '1', { expires: 1 });
      this.sidebarVideo = true;

      const sidebarVideoPlayer = (
        <SiderailVideoModuleReactJW
          config={config}
          type="rightrail"
          playerid="2fyG0pBE"
          playlistId={
            this.useMicrosoftPlaylist
              ? '9JiEM2iD' // Right Rail Playlist (Microsoft)
              : 'dOytm2y2' // Right Rail Playlist Manual
          }
          pos="newmultiplayer"
          readTime={readTime}
          customparams={customparams}
        />
      );

      ads.push(
        <div
          className="post__promotion post__promotion--non-sticky"
          key={`sidebar-nonsticky-${post.id}`}
        >
          <AdContainer type="rail_sticky" page={isFirstPost ? 1 : 2} />
        </div>,
        <div
          className="post__promotion"
          key={`post-ad-${post.id}-1`}
          id={`post-ad-${post.id}-1`}
        >
          <Sticky
            top={fullPageAdvertorial ? 150 : 100}
            bottomBoundary={`#post-ad-${post.id}-1`}
            enabled={isDesktop || false}
          >
            <Fragment>
              <div className="post__relative" key={`sidebar-video-${post.id}`}>
                {sidebarVideoPlayer}
              </div>
              <AdContainer
                type="rail_sticky"
                // hmm?:
                page={isFirstPost ? 1 : 2}
              />
            </Fragment>
          </Sticky>
        </div>
      );
    } else {
      for (let i = 0; i < totalAds; i += 1) {
        ads.push(
          <div
            key={i}
            className={this.buildClassName()}
            id={`post-ad-${post.id}-${i}`}
          >
            <Sticky
              top={fullPageAdvertorial ? 150 : 100}
              bottomBoundary={`#post-ad-${post.id}-${i}`}
              enabled={isDesktop || false}
            >
              <AdContainer type="rail_sticky" page={isFirstPost ? 1 : 2} />
              {i === 0 &&
              isLongPost &&
              !isVideoPost &&
              !tags.map(tag => tag.name).includes('*oracle_advertorial') && // Exception for Oracle
              (isCustom(get(post, 'tags')) ||
                isAdvertorial(get(post, 'tags'))) ? (
                <div className="post__relative">
                  <RelatedPosts
                    config={config}
                    stories={related.map(article =>
                      assign(article, {
                        assetSizes: imageSizesLookup.column
                      })
                    )}
                    fullPageAdvertorial={fullPageAdvertorial}
                  />
                </div>
              ) : null}
              {this.showReccommendedWidget &&
              i === 0 &&
              isLongPost &&
              !isVideoPost &&
              !tags.map(tag => tag.name).includes('*oracle_advertorial') && // Exception for Oracle
              !isAdvertorial(get(post, 'tags')) ? (
                <div className="post__relative post__relative--recommender">
                  <RelatedParselyPosts config={config} post={post} />
                </div>
              ) : null}
            </Sticky>
          </div>
        );
      }
    }

    return ads;
  }

  render() {
    if (!this.props) {
      return null;
    }
    return (
      <div
        className={`post__sidebar ${
          this.props.isVideoPost ? 'post__sidebar--video' : ''
        }`}
      >
        {this.buildSidebar()}
      </div>
    );
  }
}

Sidebar.defaultProps = {
  related: [],
  isDesktop: false,
  fullPageAdvertorial: false,
  totalAdCount: 2,
  isVideoPost: false,
  isLongPost: false
};

Sidebar.propTypes = {
  config: PropTypes.shape({}).isRequired,
  post: PropTypes.shape({}).isRequired,
  isFirstPost: PropTypes.bool.isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  isDesktop: PropTypes.bool,
  fullPageAdvertorial: PropTypes.bool,
  totalAdCount: PropTypes.number,
  isLongPost: PropTypes.bool,
  isVideoPost: PropTypes.bool
};
